module.exports = {"resolutionCenter":"/signin/?returnUri={originURL}/disputes"}